import { AsyncSettingsModel } from '@syncfusion/ej2-inputs';

export const getSettings = async (): Promise<AsyncSettingsModel> => {
  // eslint-disable-next-line no-useless-catch
  try {
    const settings: AsyncSettingsModel = {
      saveUrl: `${process.env.REACT_APP_BACKEND_URL}services/file/upload`,
      chunkSize: 1024 * 1024 * 20
    };
    return settings;
  } catch (error) {
    throw error;
  }
};